

export * from './router'
export * from './user'
export * from './order'
export * from './common'

import { createPinia } from 'pinia'

export const pinia = createPinia()